import React from "react";
import { AiOutlineClockCircle } from "react-icons/ai";
import { BsPeople } from "react-icons/bs";
import { MdWarning } from "react-icons/md";
import EAChip from "../../shared/Chip/EAChip";
import EAButton from "../../shared/Buttons/EAButton";
import { SwimmingLesson } from "../../../models/SwimmingScheduleData";
import "./style.scss";

interface IProps {
  lesson: SwimmingLesson;
  onClick: (lesson: SwimmingLesson) => void;
}

const SwimmingLessonCard: React.FC<IProps> = ({ lesson, onClick }) => {
  const isFull = lesson.reserved >= lesson.capacity;
  const isPast = lesson.startTime ? lesson.startTime < Date.now() : false;
  const isUnavailable = lesson.status === "I" || isFull || isPast;
  const accentColor = lesson.buttonCollor;
  const durationMinutes = lesson.startTime && lesson.closeTime
    ? Math.round((lesson.closeTime - lesson.startTime) / 60000)
    : 0;
  const instructorName = [lesson.humanName, lesson.humanLastName].filter(Boolean).join(" ");

  return (
    <div
      className={`swimming-lesson-card ${isUnavailable ? "swimming-lesson-card--unavailable" : ""}`}
      style={accentColor ? { borderLeftColor: accentColor } : undefined}
      onClick={() => onClick(lesson)}
    >
      <div className="swimming-lesson-card__header">
        <span className="swimming-lesson-card__time" style={accentColor ? { color: accentColor } : undefined}>
          <AiOutlineClockCircle className="swimming-lesson-card__time-icon" />
          {lesson.startTime_str}
        </span>
        <span className="swimming-lesson-card__duration">{durationMinutes} min.</span>
      </div>

      <div className="swimming-lesson-card__body">
        <strong className="swimming-lesson-card__name">{lesson.name}</strong>
        {instructorName && (
          lesson.deputyHumanName ? (
            <span className="swimming-lesson-card__instructor">
              <MdWarning className="swimming-lesson-card__deputy-icon" />
              <s>{lesson.humanName}</s>
              {" "}{[lesson.deputyHumanName, lesson.deputyHumanLastName].filter(Boolean).join(" ")}
            </span>
          ) : (
            <span className="swimming-lesson-card__instructor">{instructorName}</span>
          )
        )}
      </div>

      <div className="swimming-lesson-card__footer">
        <div className="swimming-lesson-card__footer-row">
          <span className="swimming-lesson-card__spots">
            <BsPeople className="swimming-lesson-card__spots-icon" />
            {lesson.reserved}/{lesson.capacity}
          </span>
        </div>

        <div className="swimming-lesson-card__footer-row swimming-lesson-card__footer-row--action">
          <EAChip label={lesson.courseType === "SwimmingLessonSemester" ? "Semestr" : "Dynamiczny"} variant="default" />

          {isUnavailable ? (
            <span className="swimming-lesson-card__unavailable-label">Niedostępny</span>
          ) : (
            <div onClick={(e) => e.stopPropagation()}>
              <EAButton title="Zapisz się" compact color="dark" onClick={() => onClick(lesson)} />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SwimmingLessonCard;
